import Http from '@/services/http';
import store from '@/store';
import { SessionData } from 'sigma-mappings';
import router from '@/router';
import NotificationService from '@/domain/services/notification';

const includesPermission = permission => store.getters.isSuperAdmin
|| store.getters.permissions.includes(permission);

export default {
  requestUserData() {
    const http = new Http({
      errorHandling: {
        ignore: true,
      },
    });
    return http.get('/usuario').then(response => this.setUserData(response.data));
  },
  validateUserPermission(permission, routeTo = 'monitoring') {
    this.requestUserData().then(() => {
      if (!this.hasAnyPermission(permission)) {
        router.push({ name: routeTo });
      }
    });
  },
  async setUserData(apiUserData) {
    const userData = new SessionData(apiUserData);
    const permissions = (userData && userData.permissions) || [];
    const setThemeAction = userData && userData.nightMode ? 'setDarkTheme' : 'setLightTheme';

    store.dispatch('setUser', userData);
    store.dispatch('setPermissions', permissions);
    if (userData.username) {
      await NotificationService.getNumberNotificationsNotRead();
    }
    store.dispatch(setThemeAction);
  },
  clearUserData() {
    this.setUserData();
  },
  hasPermission(...permissions) {
    return permissions.every(includesPermission);
  },
  hasAnyPermission(...permissions) {
    return permissions.some(includesPermission);
  },
};
